<template>
  <div class="wrapper animated fadeIn">
    <DisbursementsFilters period @load="load" />

    <div class="card">
      <div class="card-header">
        <i class="icon-check"></i> Facture coach traitées

        <div class="btn-group ml-1" role="group">
          <button
            class="btn btn-sm"
            :class="
              filter === 'not-exported' ? 'btn-primary' : 'btn-outline-primary'
            "
            @click="applyFilter('not-exported')"
          >
            Non exportés
          </button>
          <button
            class="btn btn-sm"
            :class="
              filter === 'exported' ? 'btn-primary' : 'btn-outline-primary'
            "
            @click="applyFilter('exported')"
          >
            Exportés
          </button>
          <button
            class="btn btn-sm"
            :class="filter === 'all' ? 'btn-primary' : 'btn-outline-primary'"
            @click="applyFilter('all')"
          >
            Tout
          </button>
        </div>

        <div class="pull-right">
          <span class="total inline-block">
            Total ({{ formatPrice(totalPending || "0.00€") }})
          </span>
        </div>
      </div>
      <div class="card-block">
        <DisbursementList
          v-if="!isLoading"
          :data="filteredDisbursements"
          :begin="form.begin"
          :end="form.end"
          processed
          @updateOriginalDisbursements="updateOriginalDisbursements"
        />

        <Loader v-else :isVisible="isLoading" size="small" />
      </div>
    </div>
  </div>
</template>

<script>
import DisbursementList from "@/components/coach/DisbursementList";
import DisbursementsFilters from "@/components/coach/DisbursementsFilters";
import Loader from "@/components/utils/Loader";

export default {
  components: {
    DisbursementList,
    DisbursementsFilters,
    Loader,
  },

  data() {
    return {
      originalDisbursements: [],
      disbursements: [],
      form: {
        merchant: null,
        begin: null,
        end: null,
        coachManagers: [],
      },
      isLoading: false,
      filter: "not-exported",
    };
  },

  computed: {
    totalPending() {
      let total = 0;

      if (this.disbursements?.length > 0) {
        this.disbursements.forEach((disbursement) => {
          total += disbursement.credit;
        });
      }

      return total;
    },

    disbursementsAlreadyExported() {
      return this.originalDisbursements.filter((d) => d.exportedAt).length > 0;
    },

    filteredDisbursements() {
      switch (this.filter) {
        case "all":
          return [...this.originalDisbursements];
        case "exported":
          return this.originalDisbursements.filter((d) => d.exportedAt);
        case "not-exported":
          return this.originalDisbursements.filter((d) => !d.exportedAt);
        default:
          return this.originalDisbursements;
      }
    },
  },

  methods: {
    async getDisbursements() {
      try {
        this.isLoading = true;

        const { data } = await this.$api.get("/disbursements", {
          params: {
            type: "processed",
            merchant: this.form.merchant?.value,
            begin: this.form.begin,
            end: this.form.end,
            coachs: this.form.coachs && this.form.coachs.map((c) => c.value),
            coachManagers:
              this.form.coachManagers &&
              this.form.coachManagers?.map(({ value }) => value),
          },
        });

        this.originalDisbursements = data;
        this.disbursements = data;
      } catch (e) {
        this.$errorToast("Impossible de charger les factures des coachs");
      } finally {
        this.isLoading = false;
      }
    },

    load(form) {
      this.form = form;

      this.getDisbursements();
    },

    applyFilter(filter) {
      this.filter = filter;
    },

    updateOriginalDisbursements(disbursementsId) {
      this.originalDisbursements = this.originalDisbursements.filter(
        (d) => !disbursementsId.includes(d.id),
      );
    },
  },
};
</script>
